import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { CommonSliceinitialStateInterface } from "../../types/reduxSlices";

const initialState: CommonSliceinitialStateInterface = {
  ShowChangePhoneNumberPopup: false,
  showLogoutPopup: false,
  showRewardPointsPopup: false,
  Cities: [],
  showSidebar: false,
  staffDocument: null,
  notificationData: null,
};

const commonSlice = createSlice({
  name: "commonSlice",
  initialState,
  reducers: {
    handleShowChangePhoneNumberPopup: (state, action) => {
      state.ShowChangePhoneNumberPopup = action.payload;
    },

    handleShowLogoutPopup: (state, action) => {
      state.showLogoutPopup = action.payload;
    },
    handleShowRewardPointsPopup: (state, action) => {
      state.showRewardPointsPopup = action.payload.showRewardPointsPopup;
      state.notificationData = action.payload.notificationData || null;
    },
    UpdateCities: (state, action: PayloadAction<any>) => {
      state.Cities = action.payload;
    },
    handleShowHideSidebar: (state, action: PayloadAction<any>) => {
      state.showSidebar = action.payload;
    },
    setStaffDocument: (state, action) => {
      state.staffDocument = action.payload;
    }
  },
});

export const {
  handleShowChangePhoneNumberPopup,
  UpdateCities,
  handleShowLogoutPopup,
  handleShowHideSidebar,
  setStaffDocument,
  handleShowRewardPointsPopup
} = commonSlice.actions;

export default commonSlice.reducer;
